export default class PaymentCard {
  constructor(initializer) {
    this.payment_card_type = initializer.payment_card_type;
    this.payment_card_token = initializer.payment_card_token;
    this.payment_card_name = initializer.payment_card_name;
    this.valid_from = initializer.valid_from;
    this.valid_to = initializer.valid_to;
    this.electronic_check_account_type =
      initializer.electronic_check_account_type;
    this.electronic_check_rdfi_number =
      initializer.electronic_check_rdfi_number;
    this.isDefault = initializer.default;
  }
}
